import React from 'react';
import styled, { useTheme } from 'styled-components';
import Plus from 'assets/plus.svg';
import { Typography } from '../../Typography';
import { InfoTooltip } from "../../Tooltip/InfoTooltip";

interface FormListControlProps {
  id?: string;
  name: string;
  label: string
  noItemsLabel: string
  addItemLabel: string
  onAddItem: () => Promise<void> | void;
  tooltip?: React.ReactNode;
  children?: React.ReactNode;
  totalItems: number;
  required?: boolean;
  isDisabled?: boolean

}

export const FormListControl: React.FC<FormListControlProps> = ({
  id,
  name,
  label,
  noItemsLabel,
  addItemLabel,
  onAddItem,
  tooltip,
  children,
  totalItems,
  required = false,
  isDisabled = false
}) => {

  const theme = useTheme();
  return (
    <Container id={id}>
      <Title>
        <Label>
          <Typography variant="body6">
            <label htmlFor={name}>{label} {required && <span style={{ color: '#6777FF' }}>*</span>}</label>
          </Typography>
          {tooltip && <InfoTooltip name={`input-tooltip-${name}`} tooltip={tooltip} />}
        </Label>
        <AddButton
          onClick={!isDisabled ? onAddItem : undefined}
          style={{
            opacity: isDisabled ? 0.5 : 1,
            pointerEvents: isDisabled ? 'none' : 'auto',
          }}
        >
          <Plus color={theme.palette.background.primary} />
          <Typography variant="body6" color={theme.palette.text.link}>
            {addItemLabel}
          </Typography>
        </AddButton>
      </Title>
      {totalItems > 0 ? (
        <Content>
          {children}
        </Content>
      ) : (
        <NoItems>
          <Typography variant="body7" color="#585858">{noItemsLabel}</Typography>
        </NoItems>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Label = styled.div`
  display: flex;
  gap: 4px;
`;

const NoItems = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #E9E9E9;
  border-radius: 15px;
  height: 75px;
  width: 100%;
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
`;

const AddButton = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  gap: 5px;
`;


